import { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Story } from './pages/Story';
import { Home } from './pages/Home';
import { LayoutDispatch } from './components/navigators/LayoutDispatch';
import { ContentJson } from './model/ContentJson';

type BackPrev = {
  prevKey?: string;
  nextKey?: string;
}
type KeyBackPrev = {
  [currentKey: string]: BackPrev;
}

function App() {

  const [contentJson, setContentJson] = useState<ContentJson | null>({});

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const contentResponse = await fetch("/assets/content.json");
        if (!contentResponse.ok) {
          throw new Error('Failed to fetch content');
        }
        const content = await contentResponse.json()
        setContentJson(content);

      } catch (error) {
        console.error('Error fetching content:', error);
      }
    }

    fetchContent();
  }, [])

  function getRoutes() {
    let keyBackPrev: KeyBackPrev = {};
    const keys = Object.keys(contentJson!);
    for (let i = 0; i < keys.length; i++) {
      let currentKey = keys[i];
      let prevKey = i > 0 ? keys[i - 1] : undefined;
      let nextKey = i < keys.length - 1 ? keys[i + 1] : undefined;
      keyBackPrev[currentKey] = { prevKey, nextKey }
    };

    return (
      Object.entries(contentJson!).map(([key, value]) => (
        <Route key={key} path={key} element={<Story num={key} value={value} prevKey={keyBackPrev[key].prevKey} nextKey={keyBackPrev[key].nextKey} />} />
      ))
    )
  }

  return (
    <>
      {!contentJson ? (
        <div>Wait...</div>
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<LayoutDispatch contentJson={contentJson} />}>
              <Route index element={<Home />} />
              {getRoutes()}
            </Route>
          </Routes>
        </BrowserRouter>
      )}
    </>
  )
}

export default App;
